document.addEventListener('DOMContentLoaded', () => {
    let element = document.querySelector('.shipping-text'),
        quickship = convertToBoolean(element.getAttribute('data-quickship')),
        rsQuickshipInventory = convertToBoolean(element.getAttribute('data-quickship-inventory')),
        appShippingMessage = element.getAttribute('data-shipping-message');

    element.innerText = createShippingText(quickship, rsQuickshipInventory, getDateTime());

    function convertToBoolean(value) {
        switch (value) {
            case 'true':
            case true:
                return true;
            default:
                return false;
        }
    }

    function getDateTime() {
        let dateTime = {
            dayOfWeek: new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                weekday: 'short'
            }).format(new Date()),
            time: new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).format(new Date())
        }

        return dateTime;
    }

    function createShippingText(quickship, rsQuickshipInventory, dateTime) {
        let currentDay = dateTime.dayOfWeek,
            currentTime = dateTime.time,
            isWeekend = (
                (currentDay === 'Fri' && currentTime > '13:00') ||
                currentDay === 'Sat' ||
                currentDay === 'Sun' ||
                (currentDay === 'Mon' && currentTime < '00:01')
            ),
            text;

        if (isWeekend) {
            if (quickship && rsQuickshipInventory) {
                text = 'Typically ships in 1-2 days!';
            } else {
                text = `${appShippingMessage} from the manufacturer.`;
            }
        } else {
            if (!quickship) {
                text = `${appShippingMessage} from the manufacturer.`;
            }
            if (quickship && rsQuickshipInventory) {
                text = 'Order by 1:00pm EST it ships today!';
            }
            if (quickship && !rsQuickshipInventory) {
                text = 'Typically ships in 2-3 days from the manufacturer!';
            }
        }

        return text;
    }
});